module.exports = __webpack_public_path__ + "img/cup.9c975d92.png";